export enum PatientType {
    converted = "converted",
    preconverted = "preconverted"
  };